import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';
import type { ApiResponse, TrainingTag } from './types';

export function useTags() {
  return useQuery({
    queryKey: QUERY_KEYS.tags,
    queryFn: () => api.get<ApiResponse<TrainingTag[]>>('/api/v1/tags'),
    select: (res) => res.data,
  });
}

export function useCreateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; color?: string; weight?: number }) =>
      api.post<ApiResponse<TrainingTag>>('/api/v1/tags', body),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.tags }),
  });
}

export function useUpdateTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: { id: string; name?: string; weight?: number; is_active?: number; color?: string }) =>
      api.patch(`/api/v1/tags/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.tags }),
  });
}

export function useDeleteTag() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/tags/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEYS.tags }),
  });
}
